import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormGroupRawValue } from '../../helpers/types.utils';

/**
 * Field: Citation Title
 */
export function createCitationTitleField(
  initialValue = ''
): FormControl<string> {
  return new FormControl<string>(initialValue, {
    nonNullable: true,
    validators: [Validators.required]
  });
}

/**
 * Field: Citation Issue
 */
export function createCitationIssueField(
  initialValue = ''
): FormControl<string> {
  return new FormControl<string>(initialValue, {
    nonNullable: true,
    validators: [Validators.required]
  });
}

/**
 * Field: Required Step or Training
 */
export function createCitationRequiredStepOrTrainingField(
  initialValue = ''
): FormControl<string> {
  return new FormControl<string>(initialValue, {
    nonNullable: true
  });
}

/**
 * Type definition for the CreateUpdateContractorCitation FormGroup structure
 */
export type CreateUpdateContractorCitationFormGroup = FormGroup<{
  title: ReturnType<typeof createCitationTitleField>;
  issue: ReturnType<typeof createCitationIssueField>;
  requiredStepOrTraining: ReturnType<
    typeof createCitationRequiredStepOrTrainingField
  >;
}>;

/**
 * Interface for Citation creation form value
 */
export type CreateUpdateContractorCitationFormValue =
  FormGroupRawValue<CreateUpdateContractorCitationFormGroup>;

/**
 * Creates a complete FormGroup for Citation creation
 */
export function createUpdateContractorCitationForm(
  initial?: Partial<CreateUpdateContractorCitationFormValue>
): CreateUpdateContractorCitationFormGroup {
  return new FormGroup({
    title: createCitationTitleField(initial?.title),
    issue: createCitationIssueField(initial?.issue),
    requiredStepOrTraining: createCitationRequiredStepOrTrainingField(
      initial?.requiredStepOrTraining
    )
  });
}
